import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncOverdueLoan = loadable(() => import('./OverdueLoan'), {
  fallback: <Loader />,
});
